import Http from "@/global/axios";
// 首页
export const cateGory = (params) => new Http().require({ api: { controller: 'shop', action: 'category' }, param: params });
